
import React from "react";
import { Container, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "../styles/bottomNavigation.css";

function BottomNavigation() {
  return (
    <nav className="bottom-navigation" aria-label="Main navigation">
      <Container>
        <Nav className="d-flex flex-row justify-content-around align-items-center">

          {/* Home */}
          <Nav.Link
            as={NavLink}
            to="/"
            end
            className="bottom-nav-link"
          >
            <span className="bottom-nav-icon">🏠</span>
            <span>Home</span>
          </Nav.Link>

          {/* About */}
          <Nav.Link
            as={NavLink}
            to="/about"
            className="bottom-nav-link"
          >
            <span className="bottom-nav-icon">ℹ️</span>
            <span>About</span>
          </Nav.Link>

          {/* Install */}
          <Nav.Link
            as={NavLink}
            to="/install"
            className="bottom-nav-link"
          >
            <span className="bottom-nav-icon">📲</span>
            <span>Install</span>
          </Nav.Link>

          {/* Support */}
          <Nav.Link
            as={NavLink}
            to="/support"
            className="bottom-nav-link"
          >
            <span className="bottom-nav-icon">❤️</span>
            <span>Support</span>
          </Nav.Link>

        </Nav>
      </Container>
    </nav>
  );
}

export default BottomNavigation;
